import { Component, OnDestroy, OnInit } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { REGEX } from "../../../shared/utility/utility";

@Component({
  selector: 'ngb-reset-psw',
  templateUrl: './reset-psw.component.html',
  styleUrl: './reset-psw.component.scss',
  imports: [
    SharedModule,
  ],
})

export class ResetPasswordModalComponent implements OnInit,OnDestroy {

  form: FormGroup;
  
  
  constructor(    private _fb: FormBuilder,private dialogRef: MatDialogRef<ResetPasswordModalComponent>) {}
  
  ngOnInit(): void {
    this.form = this._fb.group({
        username: ['', [Validators.required, Validators.pattern(REGEX.email)]],
    });
  }
  
  ngOnDestroy(): void {}

  submit() {        
    if (this.form.valid) {
    this.dialogRef.close(this.form.value.username);
    }
}

  cancel() {
    this.dialogRef.close();
  }

}
